// extracted by mini-css-extract-plugin
export default {"CategorySelection":"CategorySelection-module-b003ee931705b66a6ba4","category":"CategorySelection-module-bcbb79b3b22b880fbdfc"};